












































































































































































// import throttle from 'lodash/throttle';
import { defineComponent, reactive, toRefs, PropType, onMounted, computed, watch } from '@vue/composition-api';
// @ts-ignore
import axios from '@services/service';
// @ts-ignore
import { sendLog } from '@common/log';
// @ts-ignore
import { getKpn, formateNum } from '@common/util';
import Banner from '../banner/index.vue';

export default defineComponent({
    components: {
        Banner,
    },
    emits: ['handleOpenKwai'],
    setup(props, { root, emit }: any) {
        const {
            initData: { userData, photoList, appsflyer, kpn: k, appName, shareUserInfo, isRtl, isSupportWebp, ABConfig: config },
            message: { localLang: lang },
        } = root.$store.state;

        const state = reactive({
            tabIndex: 0,
            liksList: [],
            showBottomBanner: false,
            showPop: false,
            timer: null,
        });

        const headUrl = () => {
            const { headurl, tinyHeadUrl } = userData.profile || {};
            // 优先用大图
            return headurl || tinyHeadUrl;
        };

        const getLiksList = async () => {
            // @ts-ignore
            const { kpn: queryKpn, source = '', source_type = '', bkt = '' } = root?.$route?.query || {};
            const kpn = k || getKpn(window.location.host, queryKpn || '');
            try {
                const { result, feeds } = await axios.post(`/rest/o/w/v0/feed/liked?kpn=${kpn}`, {
                    userId: userData.profile?.user_id,
                    count: 18,
                    kpn,
                    source,
                    source_type,
                    bkt,
                });

                if (result === 1 && feeds?.length) {
                    state.liksList = feeds;
                }
            } catch (error) {
                state.liksList = [];
            }
        };

        const setPopup = () => {
            clearTimeout(state.timer);
            if (!config?.popup?.canShow) return;

            state.timer = setTimeout(() => {
                state.showPop = true;
                sendLog({
                    type: 'show',
                    name: 'WATCH_WITH_KWAI_POPUP',
                });
            }, 8000);
        };

        const onScroll = () => {
            setPopup();
            const scrollTop = window.scrollY;
            state.showBottomBanner = scrollTop > 180;
        };

        watch(
            () => state.showBottomBanner,
            value => {
                if (!value) return;
                sendLog({
                    type: 'show',
                    name: 'BOTTOM_BANNER_CARD',
                    value: {
                        ext_params: JSON.stringify(config?.bottomBanner || {}),
                    },
                });
            }
        );

        const clickLog = ({ clickSource = '', event, pkgParams }: any) => {
            const actionMap = {
                name: 'NICKNAME_BUTTON',
                picture: 'HEAD_BUTTON',
                follow: 'USER_FOLLOW',
                follower: 'FOLLOWER_BUTTON',
                following: 'FOLLOWING_BUTTON',
                topbanner: 'TOP_BANNER_CARD',
                bottombanner: 'BOTTOM_BANNER_CARD',
                popup: 'WATCH_WITH_KWAI_POPUP_BUTTON',
                PLAY_PHOTO: 'PLAY_PHOTO',
                SWITCH_TAB: 'SWITCH_TAB',
            };

            const action = actionMap[clickSource] || '';
            const params: any = {};

            // 增加参数：关注人数
            const { follow, fan } = userData?.ownerCount || {};
            if (action === 'FOLLOWING_BUTTON') {
                params.num = follow;
            }
            if (action === 'FOLLOWER_BUTTON') {
                params.num = fan;
            }

            // 增加参数：banner点击位置
            if (['TOP_BANNER_CARD', 'BOTTOM_BANNER_CARD'].includes(action)) {
                const isButton = event.target.className?.includes('button');
                params.click_area = isButton ? 'BUTTON' : 'BANNER';
                const extParams = action === 'TOP_BANNER_CARD' ? config.topBanner : config.bottomBanner;
                params.ext_params = JSON.stringify(extParams || {});
            }

            // 增加参数：弹窗点击按钮
            if (action === 'WATCH_WITH_KWAI_POPUP_BUTTON') {
                params.button_name = event.target?.dataset?.log;
            }

            // 增加参数：视频信息
            if (['PLAY_PHOTO', 'SWITCH_TAB'].includes(action)) {
                Object.assign(params, pkgParams);
            }

            sendLog({
                type: 'click',
                name: action,
                value: params,
            });
        };

        const openOrDownload = (clickSource: string, event) => {
            emit('handleOpenKwai', clickSource);

            clickLog({ clickSource, event });
        };

        const setTabIndex = (index: number) => {
            state.tabIndex = index;
            if (index === 1 && !state.liksList?.length) {
                getLiksList();
            }

            clickLog({
                clickSource: 'SWITCH_TAB',
                pkgParams: {
                    tab_name: ['post', 'likes'][index],
                },
            });
            setPopup();
        };

        const popupContentText = computed(() => {
            return lang.share_photo_popup?.replace(/\$?\{(.*?)\}/, `${appName}`) || '';
        });

        const getCoverUrl = (item: any) => {
            if (isSupportWebp && item.webpCoverUrls?.length) {
                return item.webpCoverUrls[0].url;
            }
            return item.coverUrls[0].url;
        };

        // 性别文案
        const getGenderString =
            {
                M: lang.gender_male,
                F: lang.gender_female,
                N: lang.gender_neuter,
                S: lang.gender_secret,
            }[userData.profile?.user_sex] || '';

        onMounted(() => {
            window.addEventListener('scroll', onScroll);
            setPopup();

            // 顶部banner show
            sendLog({
                type: 'show',
                name: 'TOP_BANNER_CARD',
                value: {
                    ext_params: JSON.stringify(config?.topBanner || {}),
                },
            });

            // 作品曝光
            root.$Lazyload.$on('loaded', ({ el }) => {
                const { index, photoid } = el?.dataset || {};
                sendLog({
                    type: 'show',
                    name: 'SHOW_PHOTO',
                    value: {
                        index,
                        photo_id: photoid,
                    },
                });
            });
        });

        return {
            ...toRefs(state),
            headUrl: headUrl(),
            getGenderString,
            popupContentText,
            formateNum,
            setTabIndex,
            openOrDownload,
            setPopup,
            clickLog,
            getCoverUrl,
            userData,
            photoList,
            lang,
            appsflyer,
            shareUserInfo,
            config,
            isRtl,

        };
    },
});
